const API_BASE = import.meta.env.VITE_API_BASE
  || import.meta.env.VITE_API_BASE_URL
  || 'https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev'

export async function fetchSalesSummary() {
  const response = await fetch(`${API_BASE}/sales-summary`)
  if (!response.ok) {
    throw new Error(`Sales summary API error: ${response.status}`)
  }
  return response.json()
}
